export default __webpack_public_path__ + "static/media/755ab935ec3c301168fe2674e7179adb.svg";